import { render } from "./CallsChart.vue?vue&type=template&id=96a5c9d2"
import script from "./CallsChart.vue?vue&type=script&lang=js"
export * from "./CallsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__